import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { GProps, G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <desc id="IMP.BLUE">{"#AddUserIcon":{"type":"SELECTOR","constraint":"none","width":20,"height":19},"#Vector":{"type":"SELECTOR","constraint":"none","width":6.30859375,"height":6.30859375},"tProps":{"type":"PROPS","InviteButtonSmall?":{"onPress":"Function"}},"#InviteButtonSmall":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.InviteButtonSmall?.onPress"},"constraint":"xMinYMin meet","width":40,"height":40}}</desc>
 * <g id="InviteButtonSmall">
 * <path d="M0 3C0 1.34315 1.34315 0 3 0H37C38.6569 0 40 1.34315 40 3V37C40 38.6569 38.6569 40 37 40H3C1.34315 40 0 38.6569 0 37V3Z" fill="#2C4B46"/>
 * <g id="AddUserIcon">
 * <path id="Vector" d="M22.5811 20.8426L22.5811 20.8426C22.9747 21.0296 23.4454 20.8623 23.6325 20.4687C23.8196 20.0751 23.6522 19.6044 23.2586 19.4173C22.9974 19.2931 22.7319 19.1824 22.4625 19.0855C23.4872 18.2338 24.1411 16.9497 24.1411 15.5156C24.1411 12.9567 22.0594 10.875 19.5005 10.875C16.9415 10.875 14.8599 12.9567 14.8599 15.5156C14.8599 16.9512 15.5151 18.2364 16.5416 19.0881C15.6005 19.4255 14.7171 19.9232 13.9369 20.5649C12.3966 21.8319 11.3256 23.599 10.9212 25.5415C10.7886 26.1781 10.9475 26.8325 11.3571 27.3361C11.7647 27.8374 12.3695 28.125 13.0157 28.125H21.1938C21.6296 28.125 21.9829 27.7717 21.9829 27.3359C21.9829 26.9001 21.6296 26.5469 21.1938 26.5469H13.0157C12.7841 26.5469 12.6452 26.4189 12.5814 26.3405C12.4729 26.207 12.4307 26.0334 12.4662 25.8631L12.3441 25.8377L12.4662 25.8631C13.1431 22.6114 16.0112 20.2348 19.3236 20.1529C19.3823 20.1551 19.4412 20.1562 19.5005 20.1562C19.5603 20.1562 19.6199 20.1551 19.6792 20.1529C20.6936 20.1772 21.6687 20.4089 22.5811 20.8426ZM22.563 15.5156C22.563 17.1505 21.2749 18.4906 19.6604 18.574C19.6072 18.5731 19.5539 18.5726 19.5005 18.5726C19.4475 18.5726 19.3946 18.5731 19.3418 18.574C17.7267 18.4913 16.438 17.1509 16.438 15.5156C16.438 13.8271 17.8119 12.4531 19.5005 12.4531C21.189 12.4531 22.563 13.8271 22.563 15.5156Z" fill="white" stroke="white" stroke-width="0.25"/>
 * <path id="Vector_2" d="M28.3359 24.0566H26.6348V22.3555C26.6348 21.9197 26.2815 21.5664 25.8457 21.5664C25.4099 21.5664 25.0566 21.9197 25.0566 22.3555V24.0566H23.3555C22.9197 24.0566 22.5664 24.4099 22.5664 24.8457C22.5664 25.2815 22.9197 25.6348 23.3555 25.6348H25.0566V27.3359C25.0566 27.7717 25.4099 28.125 25.8457 28.125C26.2815 28.125 26.6348 27.7717 26.6348 27.3359V25.6348H28.3359C28.7717 25.6348 29.125 25.2815 29.125 24.8457C29.125 24.4099 28.7717 24.0566 28.3359 24.0566Z" fill="white" stroke="white" stroke-width="0.25"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#AddUserIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 19
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 6.30859375,
 * 		"height": 6.30859375
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"InviteButtonSmall?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#InviteButtonSmall": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.InviteButtonSmall?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "xMinYMin meet",
 * 		"width": 40,
 * 		"height": 40
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  InviteButtonSmall?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const InviteButtonSmall = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  InviteButtonSmall?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 40,
      height: 40,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    InviteButtonSmallButtonOpacity: number;
  }>({
    InviteButtonSmallButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region InviteButtonSmall Button Handlers

  // eslint-disable-next-line no-shadow
  const { InviteButtonSmall = {} } = props;
  const { onPress: InviteButtonSmallOnPress, ...InviteButtonSmallProps } = InviteButtonSmall as tButtonProps;

  const InviteButtonSmallButtonPressInFunction = () => 0;

  const InviteButtonSmallButtonPressOutFunction = InviteButtonSmallOnPress;

  const InviteButtonSmallButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, InviteButtonSmallButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const InviteButtonSmallButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, InviteButtonSmallButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const InviteButtonSmallOnPressIn = () => {
    InviteButtonSmallButtonActive(InviteButtonSmallButtonPressInFunction);
  };

  const InviteButtonSmallOnPressOut = () => {
    InviteButtonSmallButtonInactive(InviteButtonSmallButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 40 40"
        >
          <G
            id="InviteButtonSmall"
            opacity={buttonState.InviteButtonSmallButtonOpacity}
            onMouseDown={InviteButtonSmallOnPressIn}
            onMouseUp={InviteButtonSmallOnPressOut}
            cursor="pointer"
            {...InviteButtonSmallProps}
          >
            <Path
              d="M0 3C0 1.34315 1.34315 0 3 0H37C38.6569 0 40 1.34315 40 3V37C40 38.6569 38.6569 40 37 40H3C1.34315 40 0 38.6569 0 37V3Z"
              fill="#2C4B46"
              id="InviteButtonSmall_elem0"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
              <G id="AddUserIcon">
                <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
                  <Path
                    id="Vector"
                    d="M22.5811 20.8426L22.5811 20.8426C22.9747 21.0296 23.4454 20.8623 23.6325 20.4687C23.8196 20.0751 23.6522 19.6044 23.2586 19.4173C22.9974 19.2931 22.7319 19.1824 22.4625 19.0855C23.4872 18.2338 24.1411 16.9497 24.1411 15.5156C24.1411 12.9567 22.0594 10.875 19.5005 10.875C16.9415 10.875 14.8599 12.9567 14.8599 15.5156C14.8599 16.9512 15.5151 18.2364 16.5416 19.0881C15.6005 19.4255 14.7171 19.9232 13.9369 20.5649C12.3966 21.8319 11.3256 23.599 10.9212 25.5415C10.7886 26.1781 10.9475 26.8325 11.3571 27.3361C11.7647 27.8374 12.3695 28.125 13.0157 28.125H21.1938C21.6296 28.125 21.9829 27.7717 21.9829 27.3359C21.9829 26.9001 21.6296 26.5469 21.1938 26.5469H13.0157C12.7841 26.5469 12.6452 26.4189 12.5814 26.3405C12.4729 26.207 12.4307 26.0334 12.4662 25.8631L12.3441 25.8377L12.4662 25.8631C13.1431 22.6114 16.0112 20.2348 19.3236 20.1529C19.3823 20.1551 19.4412 20.1562 19.5005 20.1562C19.5603 20.1562 19.6199 20.1551 19.6792 20.1529C20.6936 20.1772 21.6687 20.4089 22.5811 20.8426ZM22.563 15.5156C22.563 17.1505 21.2749 18.4906 19.6604 18.574C19.6072 18.5731 19.5539 18.5726 19.5005 18.5726C19.4475 18.5726 19.3946 18.5731 19.3418 18.574C17.7267 18.4913 16.438 17.1509 16.438 15.5156C16.438 13.8271 17.8119 12.4531 19.5005 12.4531C21.189 12.4531 22.563 13.8271 22.563 15.5156Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.25"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Path
                  id="Vector_2"
                  d="M28.3359 24.0566H26.6348V22.3555C26.6348 21.9197 26.2815 21.5664 25.8457 21.5664C25.4099 21.5664 25.0566 21.9197 25.0566 22.3555V24.0566H23.3555C22.9197 24.0566 22.5664 24.4099 22.5664 24.8457C22.5664 25.2815 22.9197 25.6348 23.3555 25.6348H25.0566V27.3359C25.0566 27.7717 25.4099 28.125 25.8457 28.125C26.2815 28.125 26.6348 27.7717 26.6348 27.3359V25.6348H28.3359C28.7717 25.6348 29.125 25.2815 29.125 24.8457C29.125 24.4099 28.7717 24.0566 28.3359 24.0566Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.25"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 40 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          d="M0 3C0 1.34315 1.34315 0 3 0H37C38.6569 0 40 1.34315 40 3V37C40 38.6569 38.6569 40 37 40H3C1.34315 40 0 38.6569 0 37V3Z"
          fill="#2C4B46"
          id="InviteButtonSmall_elem0"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 40 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="AddUserIcon">
          <Path
            id="Vector"
            d="M22.5811 20.8426L22.5811 20.8426C22.9747 21.0296 23.4454 20.8623 23.6325 20.4687C23.8196 20.0751 23.6522 19.6044 23.2586 19.4173C22.9974 19.2931 22.7319 19.1824 22.4625 19.0855C23.4872 18.2338 24.1411 16.9497 24.1411 15.5156C24.1411 12.9567 22.0594 10.875 19.5005 10.875C16.9415 10.875 14.8599 12.9567 14.8599 15.5156C14.8599 16.9512 15.5151 18.2364 16.5416 19.0881C15.6005 19.4255 14.7171 19.9232 13.9369 20.5649C12.3966 21.8319 11.3256 23.599 10.9212 25.5415C10.7886 26.1781 10.9475 26.8325 11.3571 27.3361C11.7647 27.8374 12.3695 28.125 13.0157 28.125H21.1938C21.6296 28.125 21.9829 27.7717 21.9829 27.3359C21.9829 26.9001 21.6296 26.5469 21.1938 26.5469H13.0157C12.7841 26.5469 12.6452 26.4189 12.5814 26.3405C12.4729 26.207 12.4307 26.0334 12.4662 25.8631L12.3441 25.8377L12.4662 25.8631C13.1431 22.6114 16.0112 20.2348 19.3236 20.1529C19.3823 20.1551 19.4412 20.1562 19.5005 20.1562C19.5603 20.1562 19.6199 20.1551 19.6792 20.1529C20.6936 20.1772 21.6687 20.4089 22.5811 20.8426ZM22.563 15.5156C22.563 17.1505 21.2749 18.4906 19.6604 18.574C19.6072 18.5731 19.5539 18.5726 19.5005 18.5726C19.4475 18.5726 19.3946 18.5731 19.3418 18.574C17.7267 18.4913 16.438 17.1509 16.438 15.5156C16.438 13.8271 17.8119 12.4531 19.5005 12.4531C21.189 12.4531 22.563 13.8271 22.563 15.5156Z"
            fill="white"
            stroke="white"
            strokeWidth="0.25"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Vector_2"
            d="M28.3359 24.0566H26.6348V22.3555C26.6348 21.9197 26.2815 21.5664 25.8457 21.5664C25.4099 21.5664 25.0566 21.9197 25.0566 22.3555V24.0566H23.3555C22.9197 24.0566 22.5664 24.4099 22.5664 24.8457C22.5664 25.2815 22.9197 25.6348 23.3555 25.6348H25.0566V27.3359C25.0566 27.7717 25.4099 28.125 25.8457 28.125C26.2815 28.125 26.6348 27.7717 26.6348 27.3359V25.6348H28.3359C28.7717 25.6348 29.125 25.2815 29.125 24.8457C29.125 24.4099 28.7717 24.0566 28.3359 24.0566Z"
            fill="white"
            stroke="white"
            strokeWidth="0.25"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(InviteButtonSmall);
